var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(chat){return _c('Chat',{key:chat.id,ref:(_vm.$route.params.chatId === chat.id) ? 'selected' : undefined,refInFor:true,attrs:{"chat":chat}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }